import * as CustomerHelpers from 'shared-web/src/helpers/CustomerHelpers'

import { CustomerAPI, json, checkStatus } from '@driftt/dapper'

const hasNotifications = ('Notification' in window)

const ensureNotificationPermission = function(cb) {
  // const's check if the browser supports notifications
  if ((typeof window === 'undefined' || window === null) || !hasNotifications) {
    return
  }

  if (Notification.permission === 'granted') {
    return cb()
  } else if (Notification.permission !== 'denied') {
    return Notification.requestPermission(function(permission) {
      if (permission === 'granted') { return cb() }
    })
  }
}

export const showNotification = (notification, options, handleClick) => {
  hasNotifications && ensureNotificationPermission(function() {
    const n = new Notification(notification, options)
    n.onclick = handleClick
    return setTimeout((() => n.close()), 10000)
  })
}

const redirectToNewConversation = (endUserId, opts = {}) => event => {
  event.preventDefault()
  return endUserId
    ? window.open(`/inboxes?endUserId=${endUserId}`)
    : window.open(`/live?user=${opts.anonymousId}&account=${opts.accountName}`)
}

const redirectToConversation = message => function(event) {
  event.preventDefault()
  return window.open(`/inboxes/${message.inboxId}/conversations/${message.conversationId}`)
}

export const notifyNewMessage = function(message) {
  const strippedBody = message.attributes && message.attributes.preview
  const hasAttachment = message.attachments && message.attachments.length
  const messageToShow = hasAttachment ? '\n📎 Message sent with attachment.' : (message.subject || strippedBody)

  return showNotification(`#${ message.conversationId } ${ messageToShow }`, {
    body: strippedBody,
    tag: `message${message.id}`,
    icon: require('images/notification-logo.png')
  },
  redirectToConversation(message))
}

export const notifyNewParticipant = function(message) {
  const strippedBody = message.attributes && message.attributes.preview
  return showNotification(`#${ message.conversationId } ${ message.subject || strippedBody }`, {
    body: "You’ve been added to a conversation in Drift. Click here to view it.",
    tag: `message${message.id}`,
    icon: require('images/notification-logo.png')
  },
    redirectToConversation(message)
  )
}

export const notifyFollowing = (payload) => {

  const message = `[Live View] ${CustomerHelpers.getDisplayName(payload.endUser)} is on your site: ${_.get(event, 'attributes.title') || _.get(event, 'attributes.url')}!`
  return showNotification(
    message,
    {
      tag: message,
      icon: require('images/notification-logo.png')
    },
    redirectToNewConversation(payload.endUser.id)
  )
}

export const notifyFollowingAccount = ({ account, event, companyData }) => {
  const message = `[ABM] ${account.name} is on your site: ${_.get(event, 'attributes.title') || _.get(event, 'attributes.url')}!`
  showNotification(
    message,
    {
      tag: message,
      body: `Page: ${event.attributes.title || event.attributes.url}`,
      icon: companyData.logo || require('images/notification-logo.png')
    },
    redirectToNewConversation(event.driftId, { anonymousId: event.anonymousId, accountName: account.name })
  )
}

export const notifyParticipants = (message, event) =>
  showNotification(
    message,
    { tag: message, icon: require('images/notification-logo.png') },
    redirectToConversation(event)
  )


const uniqueId = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })


const clearTabs = () => window.localStorage.setItem('openTabs', JSON.stringify([]))

const isFirstInLineCheck = () => {
  return new Promise((function(resolve) {
    const tabs = JSON.parse(window.localStorage.getItem('openTabs'))

    if (!window.thisTabID) {
      window.thisTabID = uniqueId()
    }

    tabs.push(window.thisTabID)
    window.localStorage.setItem('openTabs', JSON.stringify(tabs))

    return setTimeout(()=> {
      const latestStoredTabs = JSON.parse(window.localStorage.getItem('openTabs'))
      const firstInLine = latestStoredTabs.indexOf(window.thisTabID) === 0
      return resolve(firstInLine)
    }
    , 100)
  }.bind(this)))
}

export const soundNotification = (soundPref = 'click') =>
  isFirstInLineCheck().then(isFirstInLine => {
    if (isFirstInLine) {
      return soundNotificationImmediate(soundPref)
    }
  })

export const soundNotificationImmediate = (soundPref = 'click') => {
  return require.ensure([
    'audio/drift-click.mp3',
    'audio/drift-ding.mp3',
    'audio/drift-glossy.mp3',
    'audio/drift-pop.mp3',
    'audio/drift-xylophone.mp3'
  ], function(require) {
    if (soundPref === 'none') return

    new Audio(require(`audio/drift-${soundPref}.mp3`)).play().catch(function(error) {
      // Most likely, browser is blocking sound autoplaying before user interaction. Log so user has visibility
      console.info(error)
    })
    clearTabs()
  })
}

export const notifyAcceptedInvitation = function(user) {
  const body = `${ user.name || user.email } has joined your team!`
  return showNotification('Invitation Accepted!', {
    body,
    tag: `invite${user.id}`,
    icon: require('images/notification-logo.png')
  })
}

export const displayTabIndicator = () => {
  const originalIcon = require('images/favicon.ico')
  const newMessageIcon = require('images/favicon-unread.ico')

  const changeFavIcon = (icon) => {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = icon
    document.getElementsByTagName('head')[0].appendChild(link)
  }

  const clear = () => {
    changeFavIcon(originalIcon)
    window.onfocus = null
  }

  if (!document.hasFocus()) {
    changeFavIcon(newMessageIcon)
    window.onfocus = clear
  }
}

export const updateSubscriptionOnServer = (subscription) => {
  // Get public key and user auth from the subscription object
  const key = subscription.getKey ? subscription.getKey('p256dh') : ''
  const auth = subscription.getKey ? subscription.getKey('auth') : ''

  return CustomerAPI.post(`/notification/web/register`, {
    endpoint: subscription.endpoint,
    // Take byte[] and turn it into a base64 encoded string suitable for POSTing to a server over HTTP
    key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : '',
    authentication: auth ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth))) : ''
  })
  .then(checkStatus)
  .then(json)
}



// WEBPACK FOOTER //
// ./src/scripts/utils/NotificationHelper.js